const crop_list = {
	apricot_tree: String("APRICOT TREE"),
	aubergine: String("AUBERGINE"),
	basil: String("BASIL"),
	alfalfa: String("ALFALFA"),
	other_fruit_trees: String("OTHER FRUIT TREES"),
	almond_trees: String("ALMOND TREES"),
	anethum_graveolens: String("ANETHUM GRAVEOLENS"),
	celery: String("CELERY"),
	rice: String("RICE"),
	hazelnut_tree: String("HAZELNUT TREE"),
	corn: String("CORN"),
	durum_wheat: String("DURUM WHEAT"),
	khorasan_wheat: String("KHORASAN WHEAT"),
	soft_wheat: String("SOFT WHEAT"),
	swiss_chard: String("SWISS CHARD"),
	common_marigold: String("COMMON MARIGOLD"),
	mushrooms: String("MUSHROOMS"),
	borage: String("BORAGE"),
	hemp: String("HEMP"),
	peanut: String("PEANUT"),
	camomile: String("CAMOMILE"),
	camelina: String("CAMELINA"),
	common_cane: String("COMMON CANE"),
	khaki: String("KHAKI"),
	pumkpin: String("PUMKPIN"),
	zucchini: String("ZUCCHINI"),
	artichoke: String("ARTICHOKE"),
	chestnut_tree: String("CHESTNUT TREE"),
	onions_garlick: String("ONIONS, GARLICK"),
	chickpea: String("CHICKPEA"),
	cherry_tree: String("CHERRY TREE"),
	oat: String("OAT"),
	clementine: String("CLEMENTINE"),
	quince_tree: String("QUINCE TREE"),
	cucumber: String("CUCUMBER"),
	cabbage_and_coliflower: String("CABBAGE AND COLIFLOWER"),
	colza: String("COLZA"),
	coriander: String("CORIANDER"),
	watercress: String("WATERCRESS"),
	tail_of_rat: String("TAIL OF RAT"),
	date: String("DATE"),
	lettuce: String("LETTUCE"),
	endive_chicory: String("ENDIVE, CHICORY"),
	erbs: String("ERBS"),
	canary_grass: String("CANARY GRASS"),
	asparagus: String("ASPARAGUS"),
	aromatic_herbs: String("AROMATIC HERBS"),
	woody_aromatiques: String("WOODY AROMATIQUES"),
	spelt: String("SPELT"),
	spinach: String("SPINACH"),
	buckwheat: String("BUCKWHEAT"),
	thyme: String("THYME"),
	moreu: String("MOREU"),
	beans: String("BEANS"),
	fenugreek: String("FENUGREEK"),
	festuca: String("FESTUCA"),
	fig_tree: String("FIG TREE"),
	flowers_and_ornamental: String("FLOWERS AND ORNAMENTAL"),
	fennel: String("FENNEL"),
	fruit_trees: String("FRUIT TREES"),
	green_pea: String("GREEN PEA"),
	carob_tree: String("CAROB TREE"),
	blueberry: String("BLUEBERRY"),
	sunflower: String("SUNFLOWER"),
	redcurrant: String("REDCURRANT"),
	lying_fallow: String("LYING FALLOW"),
	lathyrus_sativus: String("LATHYRUS SATIVUS"),
	hyssop: String("HYSSOP"),
	orchard: String("ORCHARD"),
	parsley: String("PARSLEY"),
	kiwi: String("KIWI"),
	lavender: String("LAVENDER"),
	hop: String("HOP"),
	lentils: String("LENTILS"),
	linen: String("LINEN"),
	lemons: String("LEMONS"),
	strawberry: String("STRAWBERRY"),
	pomegranate_tree: String("POMEGRANATE TREE"),
	mandarin_tree: String("MANDARIN TREE"),
	marjoram: String("MARJORAM"),
	melon: String("MELON"),
	orange_blossom: String("ORANGE BLOSSOM"),
	mint: String("MINT"),
	mestall: String("MESTALL"),
	mill: String("MILL"),
	alt_beans_1: String("BEANS"),
	blueberrys: String("BLUEBERRYS"),
	chinese_turnip_and_cabbage: String("CHINESE TURNIP AND CABBAGE"),
	nashi: String("NASHI"),
	nectarine_tree: String("NECTARINE TREE"),
	medlar: String("MEDLAR"),
	walnut_trees: String("WALNUT TREES"),
	olive_trees: String("OLIVE TREES"),
	barley: String("BARLEY"),
	oregano: String("OREGANO"),
	pea_and_oat: String("PEA AND OAT"),
	peas_and_barley: String("PEAS AND BARLEY"),
	peas: String("PEAS"),
	carrot: String("CARROT"),
	potato: String("POTATO"),
	pepper: String("PEPPER"),
	pear_trees: String("PEAR TREES"),
	pear_apple_tree: String("PEAR/APPLE TREE"),
	hypericum_or_saint_johns_wort: String("HYPERICUM OR SAINT JOHN'S WORT"),
	pistachio: String("PISTACHIO"),
	bread_poa: String("BREAD/POA"),
	grapefruit: String("GRAPEFRUIT"),
	apple_trees: String("APPLE TREES"),
	peach_trees: String("PEACH TREES"),
	peach_nectarine_tree: String("PEACH/NECTARINE TREE"),
	plum_tree: String("PLUM TREE"),
	quinoa: String("QUINOA"),
	grape: String("GRAPE"),
	radish: String("RADISH"),
	ray_grass: String("RAY-GRASS"),
	beetroot: String("BEETROOT"),
	rosemary: String("ROSEMARY"),
	rye: String("RYE"),
	watermelon: String("WATERMELON"),
	saffron: String("SAFFRON"),
	sajolida: String("SAJOLIDA"),
	satsuma_tangerine: String("SATSUMA TANGERINE"),
	soy: String("SOY"),
	sorghum: String("SORGHUM"),
	sulla: String("SULLA"),
	truffle: String("TRUFFLE"),
	tobacco: String("TOBACCO"),
	orange_tree: String("ORANGE TREE"),
	tomato: String("TOMATO"),
	clover: String("CLOVER"),
	sweet_lupine: String("SWEET LUPINE"),
	sainfoin: String("SAINFOIN"),
	triticale: String("TRITICALE"),
	tritordeum: String("TRITORDEUM"),
	vetch_and_wheat: String("VETCH AND WHEAT"),
	vetch_and_oat: String("VETCH AND OAT"),
	efa_vetch_and_barley: String("EFA VETCH AND BARLEY"),
	efa_vetch_and_triticale: String("EFA VETCH AND TRITICALE"),
	vetch: String("VETCH"),
	vineyards: String("VINEYARDS"),
	nursery_tree_and_shrub: String("NURSERY TREE AND SHRUB"),
};

export default crop_list;